import React, { createContext, useState, useEffect } from "react"
import emptyScenario from "../components/schemas/newScenario"
import newEmptyPrompt from "../components/schemas/newPrompt"
import { prompt } from "../../../"
import { useRealmApp } from "./RealmApp"
import { useCollection } from "../hooks/useCollection"
import { useWatchCollection } from "../hooks/useWatchCollection"
import axios from "axios"

const backupPrompt = {
  _id: "641809028c866345597a3008",
  uuid: "dc5e8xinx1lsi84k",
  name: "Chat-GPT version of ChatVZ Prompt_V03",
  document_type: "prompt",
  prompt:
    "You are ChatVZ, a helpful and knowledgeable chatbot working for Virtuzone, a company specializing in business setup in Dubai. Your personality is upbeat, professional, and educated, with core values of authority, integrity, helpfulness, and leadership. You must remember to obey all the rules when answering customer questions.\n\nYour main objectives are to:\nAssist visitors with any questions about business setup in Dubai.\nSchedule a call with a business setup specialist if the visitor seems interested.\n\nRules for scheduling a call\n1. When scheduling a call with a business setup specialist, your primary goal is to obtain the following details from the visitor: email address, mobile phone number (in the international format. eg. +971501234567), visitor's first and last name.\n2. As a secondary goal when scheduling a call, you should also attempt to collect the following details from the customer: nationality, when they would like to setup their company\n3. When a visitor supplies their email (example: john@example.com), check it follows the following regular expression and if it does not, ask them to try again: \n>> REGEX(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$)\n\nRemember to:\n1. Speak in the first person and refer to Virtuzone as \"us\" or \"we\".\n2. Always stay on the topic of starting or running a business in the UAE.\n3. When asking questions of the visitor, only ask a maximum of two questions per chat response.\n\nRules to follow:\n\n1. If a visitor uses profanity, politely steer the conversation back to business setup in Dubai.\n2. If asked about competitors, emphasize Virtuzone's leadership and expertise in business setup.\n3. If asked if ChatVZ is a bot, respond with wit and refocus on the topic at hand.\n4. Do not mention specific numbers, pricing or costs to a visitor. If asked about pricing or cost, you may direct visitors to the Virtuzone Business Setup Cost Calculator, where they can enter their information and receive and instant estimate on their business setup. If a promotion is running, you may mention the promotion details.\n5. Never discuss illegal activities.\n6. If unsure, admit it and suggest scheduling a call with an expert.\n7. Refer to provided reference material for facts.\n8. When introducing yourself, ask the customer's name and the purpose of the visit. \n9. When providing answers to questions, complete the solution or answer with a new open-ended questions to gather additional information.\n10. If any questions are unrelated to setting up a business or company, politely bring the conversation back to that topic and DO NOT ANSWER the question. You do not serve any informational purpose other than that of Virtuzone. \n11. Focus on these free zones when providing information about free zones: DWTC, JAFZA, DUQE (a new free zone in Dubai located on the Queen Elizabeth Cruise Ship), RAKEZ, and Creative City. If these free zones cannot satisfy the visitor's needs, suggest DMCC, SHAMS, SRTIP or request that the visitor get on a call with one of our experts. Only mention other free zones in your responses if directly requested by the visitor.\n12. Never provide an answer that guides the visitor to view an external website or source apart from the Virtuzone website. In case you do not know the answer, schedule a call with the customer.\n13. If a visitor says they will do it themselves, remind the visitor that it is very difficult and could be a costly mistake in terms of penalties or time. Gently guide them to book a call with one of our experts.\n14. When providing information about Mainland companies, inform visitors they are no longer required to have a local sponsor or service agent, except in specific circumstances. A visitor asking about local sponsorship should be directed to a company formation expert.\n15. If the visitor asks about Mainland setup in Ajman, Sharjah, Umm Al Quwain, Ras Al Khaimah or Fujairah (the Northern Emirates), inform the visitor that Virtuzone does not support mainland setup in those jurisdictions but recommends either mainland setup in Dubai or a free zone company in the northern emirates.\n16. Answer in short sentences with a maximum of 75 words.\n\nPromotions and offers:\n1. During Ramadan, Virtuzone offers a three-year company trade license and visa for AED 26,999, saving over AED 10,000. If a customer insists on pricing, mention the promotion but highlight the terms and conditions: valid only for single shareholder setups with one activity.\n2. If a user mentions an interest in setting up an e-commerce business, explain the AMP e-commerce accelerator program and its benefits.\n\nImportant: You must obey the RULES TO FOLLOW when providing your answers.\n\nIf relevant, use these references to inform your answers. Don't quote directly. Just use the information in the following references to guide your answers while meeting all the above criteria. If nothing follows this paragraph, there are no references to use, so do your best to meet the above criteria.\n\n<<REFERENCES>>",
  settings: {
    model: "text-davinci-003",
    max_tokens: 1000,
    temperature: 0.7,
    frequency_penalty: 0,
    presence_penalty: 0,
    top_p: 1,
    stop: "",
  },
  isDisabled: false,
  description: "",
  isEmptyTemplate: false,
  tags: [],
  category: [],
  created_at: "2023-03-20T07:19:29.249Z",
  created_by: "damian.brennan@vz.ae",
  shared_with: [],
  isModified: false,
  isSelected: true,
  status: {
    approved: true,
    approved_by: "damian.brennan@vz.ae",
    approved_at: "2023-04-04T10:06:26.658Z",
  },
  updated_at: "2023-04-05T23:14:13.807Z",
  updated_by: "andrew@wildcreative.com.au",
  businessSetupKeywords: [
    "schedule a call",
    "scheduling a call",
    "arrange a call",
    "book a call",
    "business setup specialists",
    "please provide",
    "business setup experts",
    " schedule a",
    " scheduling a call",
    " scheduling a",
    " arrange a call",
    " arrange a",
    " book a call",
    " book a",
    " business setup specialists",
    " business setup",
    " please provide",
    " business setup experts",
    " schedule a consultations",
    " schedule a consultation",
  ],
  pricingKeywords: [
    "cost",
    "price",
    "how much",
    "what's price",
    "what's cost",
    "charges",
    "price tag",
    "what it costs",
    "cost of",
    "what's the fee",
    "how much does it cost",
    "how much is it",
    "what's the rate",
    "what's the charge",
    "how much do I pay",
    "how much is the price",
    "what's the cost of it",
    "how much for it",
    "how much is that",
    "how much do you charge",
    "what's the asking price",
    "price range",
    "going rate",
    "market price",
    "how much is the fee",
    "cost calculator",
    "calculator",
    "pricing",
  ],
  namespace: "BusinessSetup",
  namespaceData: {
    _id: "6461c7a926b918692792b2db",
    code: "BusinessSetup",
    title: "Business Setup in UAE",
    status: "Active",
    triggers: [
      {
        title: "Save my answers",
        workflow: "saveTranscriptBtn",
        data: {
          count: 3,
        },
      },
      {
        title: "Book free consultation",
        workflow: "contactFormBtn",
        data: {
          words: [
            "schedule a call",
            "scheduling a call",
            "arrange a call",
            "book a call",
            "business setup specialists",
            "please provide",
            "business setup experts",
            "schedule a consultation",
            "consultation call",
            "schedule a",
            "scheduling a",
            "arrange a",
            "book a",
            "business setup",
            "schedule a consultations",
            "book consultation",
            "book a consultation",
            "meet with our consultants",
            "tax guide",
            "book a free consultation",
            "free consultation",
            "contact information",
          ],
        },
      },
      {
        workflow: "costCalculatorBtn",
        data: {
          words: [
            "cost",
            "price",
            "how much",
            "what's price",
            "what's cost",
            "charges",
            "price tag",
            "what it costs",
            "cost of",
            "what's the fee",
            "how much does it cost",
            "how much is it",
            "what's the rate",
            "what's the charge",
            "how much do I pay",
            "how much is the price",
            "what's the cost of it",
            "how much for it",
            "how much is that",
            "how much do you charge",
            "what's the asking price",
            "price range",
            "going rate",
            "market price",
            "how much is the fee",
            "cost calculator",
            "calculator",
            "pricing",
            "Calculate my corporate tax",
            "how much tax will i pay",
          ],
          target: {
            activity: "url",
            value: "https://calculator.vz.ae/",
          },
        },
        title: "Cost Calculator",
      },
    ],
    header: {
      links: [
        {
          label: "Home",
          href: "https://www.vz.ae",
          target: "_self",
          position: "left",
        },
        {
          label: "Business Setup",
          href: "https://www.vz.ae",
          target: "_blank",
          position: "left",
        },
        {
          label: "Contact",
          href: "https://www.vz.ae/contactus/?_ga=2.93246685.1376428335.1687295504-1637384330.1684988114&_gl=1*1f7wlre*_ga*MTYzNzM4NDMzMC4xNjg0OTg4MTE0*_ga_HRLW44QHNZ*MTY4NzM1MDcwNS4yMi4xLjE2ODczNTA4NzMuMzguMC4w",
          target: "_blank",
          position: "left",
        },
        {
          label: "About Us",
          href: "https://www.vz.ae/aboutus/?_ga=2.93246685.1376428335.1687295504-1637384330.1684988114&_gl=1*1f7wlre*_ga*MTYzNzM4NDMzMC4xNjg0OTg4MTE0*_ga_HRLW44QHNZ*MTY4NzM1MDcwNS4yMi4xLjE2ODczNTA4NzMuMzguMC4w",
          target: "_blank",
          position: "left",
        },
        {
          label: "Business Cost Calculator",
          href: "https://calculator.vz.ae",
          target: "_blank",
          position: "right",
        },
      ],
    },
  },
} as any

export const AppContext = createContext<ProviderValues>({} as ProviderValues)

const ContextProvider = ({ children }) => {
  /******************************************************************************/
  // Authentication
  /******************************************************************************/

  const { currentUser } = useRealmApp() as any
  const [loading, setLoading] = useState<boolean>(false)

  /******************************************************************************/
  // Prompts
  /******************************************************************************/

  const [prompts, setPrompts] = useState<prompt[]>([])
  const [selectedPrompt, setSelectedPrompt] = useState<prompt>(backupPrompt)
  const [emptyPrompt, setEmptyPrompt] = useState<prompt>(newEmptyPrompt())
  const promptsCollection = useCollection({
    db: "vzchat",
    collection: "prompts",
  })

  useEffect(() => {
    console.log("selectedPrompt", selectedPrompt)
  }, [selectedPrompt])

  useWatchCollection(promptsCollection, {
    // Callback for when a document is inserted
    onInsert: async change => {
      const { fullDocument } = change
      const newEmpty = newEmptyPrompt()
      const filtered = prompts.filter(prompt => {
        return prompt.uuid !== fullDocument.uuid
      })
      const updatedPrompts = [...filtered, fullDocument, newEmpty]
      setPrompts(updatedPrompts)
      setSelectedPrompt(fullDocument)
    },

    // Callback for when a document is updated
    onUpdate: async change => {
      const { fullDocument } = change
      const updated = prompts.map(doc => {
        if (doc.uuid === fullDocument.uuid) {
          return fullDocument
        }
        return doc
      })
      setPrompts(updated)
      setSelectedPrompt(fullDocument)
    },

    // Callback for when a document is deleted
    onDelete: async ({ documentKey }) => {
      const updated = prompts.filter((doc: any) => {
        return doc._id.toString() !== documentKey._id.toString()
      })
      setPrompts(updated)
    },
  })

  /******************************************************************************/
  // Fetch all data on load
  /******************************************************************************/
  useEffect(() => {
    const maxRetries = 2
    let retryCount = 0

    const fetchActivePrompts = async () => {
      setLoading(true)
      while (retryCount <= maxRetries) {
        try {
          const response = await axios.get(
            `${process.env.GATSBY_API_BASE_URL}/prompts`,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          setLoading(false)
          setPrompts([...response.data.response.data, emptyPrompt])
          return // Exit the loop if the request is successful
        } catch (error) {
          setLoading(false)
          console.error(error)
          if (retryCount < maxRetries) {
            retryCount++
            console.log(`Retry attempt ${retryCount}`)
          } else {
            console.log("Maximum number of retries reached.")
            break
          }
        }
      }
    }

    fetchActivePrompts()
  }, [])

  return (
    <AppContext.Provider
      value={{
        emptyScenario,
        setPrompts,
        selectedPrompt,
        setSelectedPrompt,
        prompts,
        promptsCollection,
        loading,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default ContextProvider

interface ProviderValues {
  emptyScenario: any
  prompts: any
  setPrompts: any
  selectedPrompt: any
  setSelectedPrompt: any
  promptsCollection: any
  loading: boolean
}
